export const DEFAULT_USER_PROFILE = {
    email: '',
    privateAddress: null,
    deliveryAddress: null
};
export const DEFAULT_USER_PERMISSIONS = {
    email: false,
    research: false
};
export const DEFAULT_EMPTY_VALUE = 'empty';
// It is IMPORTANT to keep value numbers same, because
// genders associated with this numbers on the server.
// 0 - other
// 1 - male
// 2 - female
//
// IMPORTANT: Please keep the order of the objects in array. This is important,
// since somewhere we are using GENDERS[index] in code.
export const GENDERS = [
    { value: 0, label: 'GENDER_OTHER_LABEL' },
    { value: 1, label: 'GENDER_MALE_LABEL' },
    { value: 2, label: 'GENDER_FEMALE_LABEL' }
];
export const RELATIONSHIP_WITH_BORROWER = [
    { value: 0, label: 'spouse' },
    { value: 1, label: 'lifePartner' },
    { value: 2, label: 'other' }
];
// It is important to keep value number same, because
// titles associated with this numbers on the server.
// IMPORTANT: Please keep order of the objects in array.
// Since we are using TITLES[index] in code.
export const TITLES = [
    { value: 0, label: 'TITLE_DOCTOR_LABEL' },
    { value: 1, label: 'TITLE_PROF_LABEL' },
    // { value: 2, label: 'TITLE_MR_LABEL' }, // we don't need TITLE_MR_LABEL and TITLE_MRS_LABEL anymore, but we still can receive it from BE for old users, therefore we need to skip values '2' and '3'
    // { value: 3, label: 'TITLE_MRS_LABEL' },
    { value: 4, label: 'TITLE_DIPL_LABEL' },
    { value: 5, label: 'TITLE_ING_LABEL' },
    { value: 6, label: 'TITLE_PROF_DR_LABEL' }
];
export const DEALER_USERS_LIMIT = 10;
export const DEALER_ADMIN = 'isDadmin';
